var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4666_11857)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0564 32C24.893 32 32.0564 24.8366 32.0564 16C32.0564 7.16344 24.893 0 16.0564 0C7.21984 0 0.0563965 7.16344 0.0563965 16C0.0563965 24.8366 7.21984 32 16.0564 32ZM11.4059 21.448C14.7283 21.448 17.4218 18.7361 17.4218 15.3908C17.4218 12.0454 14.7285 9.33333 11.4059 9.33333C8.08324 9.33333 5.38973 12.0454 5.38973 15.3908C5.38973 18.7361 8.08344 21.448 11.4059 21.448ZM21.0215 21.0947C22.6828 21.0947 24.0296 18.541 24.0296 15.3921H24.0294C24.0294 12.2423 22.6826 9.68945 21.0213 9.68945C19.36 9.68945 18.0134 12.2432 18.0134 15.3921C18.0134 18.541 19.3602 21.0947 21.0215 21.0947ZM26.7229 15.384C26.7229 18.2047 26.2493 20.4927 25.6649 20.4927C25.0806 20.4927 24.6072 18.2053 24.6072 15.384C24.6072 12.5628 25.0808 10.2754 25.6649 10.2754C26.2491 10.2754 26.7229 12.5626 26.7229 15.384Z",
    fill: "#F0EFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4666_11857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0563965)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a232c73483bfb7a08d31d988e44a4b1c.svg";
export { ForwardRef as ReactComponent };